module.exports = __webpack_public_path__ + "static/media/midas.8e51069d.pdf";